import React from "react";
import { Reveal } from "./Reveal";
import { LucideIcon } from "./LucideIcon";
import { WHATS_INSIDE, ASSETS } from "@/data";

export const WhatsInside = () => {
  return (
    <section id="whats-inside" data-testid="whats-inside-section" className="relative py-24 md:py-32">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">What’s Inside</span>
          </div>
          <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone max-w-3xl leading-[1.05]">
            The full kit. No fluff.
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-5 gap-6">
          <Reveal className="lg:col-span-2">
            <figure className="relative h-full min-h-[320px] rounded-md overflow-hidden border border-sf-border">
              <img
                src={ASSETS.fannedCards}
                alt="Hand fanning five Sacred Frontline oracle cards"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-sf-bg via-transparent to-transparent" />
              <figcaption className="absolute bottom-5 left-5 font-mono text-xs uppercase tracking-[0.2em] text-sf-bone/90">
                49 cards · hand-illustrated
              </figcaption>
            </figure>
          </Reveal>

          <div className="lg:col-span-3 grid sm:grid-cols-2 gap-6">
            {WHATS_INSIDE.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08}>
                <div
                  data-testid="whats-inside-card"
                  className="h-full bg-sf-surface border border-sf-border rounded-md p-7 transition-colors hover:border-sf-ember/50"
                >
                  <div className="text-sf-ember mb-4">
                    <LucideIcon name={item.icon} size={26} strokeWidth={1.6} />
                  </div>
                  <h3 className="sf-stencil text-lg tracking-wide text-sf-bone">{item.title}</h3>
                  <p className="mt-2 text-sm text-sf-dim leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsInside;
